__webpack_require__.p = "/solid-data-manager/";